import {queryOptions} from '@tanstack/react-query';
import {type} from 'arktype';
import {AccountId} from '~/entities/operations-fiat';
import {expectEither, HttpClient, useHttpClient} from '~/library/network-facade';

export const SepaRequisites = type({
    beneficiary_name: 'string',
    iban: type('string | null').optional(),
});
export type SepaRequisites = typeof SepaRequisites.infer;

function fetchSepaRequisites(http: HttpClient, accountId: AccountId) {
    return http(`v1/accounts/${accountId}/send/banks/fields/sepa`).then(
        ...expectEither({
            200: SepaRequisites,
            400: null,
        })
    );
}

export function useSepaRequisitesOptions(accountId: AccountId) {
    const http = useHttpClient();
    const {queryKey, queryFn} = queryOptions({
        queryKey: ['v1/accounts/{accountId}/send/banks/fields/sepa', accountId],
        queryFn: async ({client, queryKey}) => {
            const res = await fetchSepaRequisites(http, accountId);
            switch (res.status) {
                case 200:
                    return {value: res.json};
                case 400:
                    return {problem: res.json};
                case 'Abort': {
                    await client.cancelQueries({queryKey});
                    throw res.reason;
                }
            }
        },
    });
    return {queryKey, queryFn};
}
